export default __webpack_public_path__ + "static/media/misc-pantry3-1024w.22c4a7f4.png";